import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerTitle), 1),
      _createElementVNode("img", {
        src: _ctx.closeIcon,
        alt: "close",
        class: "close-icon",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.cancel && this.cancel(...args)))
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({ maxHeight: _ctx.contentMaxHeight }),
      class: "card-content-container"
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 4),
    _createVNode(_component_BottomNavigation, {
      back: _ctx.back,
      cancel: _ctx.cancel,
      confirm: this.confirm,
      confirmButtonDisabled: !_ctx.activeValidate,
      first: _ctx.first,
      last: false,
      next: _ctx.confirm,
      smallMarginRight: true,
      class: "bottom-nav"
    }, null, 8, ["back", "cancel", "confirm", "confirmButtonDisabled", "first", "next"])
  ]))
}